module.exports = __webpack_public_path__ + "img/page22.c47454b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tax/page22.png
// module id = y+VC
// module chunks = 0